import { ChoiceScale } from "./ChoiceScale";
import { COLORS } from "@/comiq/tokens";

// Shared respondent answer control — rendered IDENTICALLY by the live respondent
// flow (/s/:token) and the admin "Pratinjau Responden". Never add admin metadata here.
export const AnswerInput = ({ item, value, onAnswer, testPrefix = "" }) => {
  if (item.item_type === "text") {
    return (
      <textarea
        value={typeof value === "string" && value !== "unsure" ? value : ""}
        onChange={(e) => onAnswer(e.target.value)}
        rows={4}
        className="w-full rounded-comiq border bg-white p-4 text-base outline-none"
        style={{ borderColor: COLORS.line, color: COLORS.ink }}
        data-testid={`${testPrefix}text-answer`}
        placeholder="Tulis jawaban Anda…"
      />
    );
  }
  if (item.options && item.options.length > 0) {
    return (
      <div className="flex flex-col gap-2.5">
        {item.options.map((o) => (
          <button
            key={o.code}
            onClick={() => onAnswer(o.code)}
            data-testid={`${testPrefix}opt-${o.code}`}
            className="rounded-comiq border bg-white px-4 py-4 text-left text-[0.98rem] transition-all"
            style={{
              borderColor: value === o.code ? COLORS.orange : COLORS.line,
              boxShadow: value === o.code ? `0 0 0 1px ${COLORS.orange} inset` : "none",
              color: COLORS.ink,
            }}
          >
            {o.label}
          </button>
        ))}
      </div>
    );
  }
  const scaleVal = typeof value === "number" ? value : value === "unsure" ? "unsure" : null;
  return <ChoiceScale value={scaleVal} onChange={onAnswer} anchors={item.scale?.anchors} allowUnsure={item.allow_unsure} testPrefix={testPrefix} unsureLabel={item.unsure_label} />;
};
